import { axios } from '../../clients/axios'
// import nodeFormData from 'form-data'

export default {
  namespaced: true,
  state: {
    notifications: []
  },
  getters: {
    getNotifications: (state) => {
      return state.notifications
    }
  },
  mutations: {
    fetchNotifications(state, notifications) {
      state.notifications = notifications
    }
  },
  actions: {
    async fetchNotificationsAction(context) {
      let uri = `${process.env.VUE_APP_API_URL}/notifications`

      const notifications = await axios.get(uri, { withCredentials: true })

      context.commit('fetchNotifications', notifications.data)

      return notifications.data
    },
    async createNotificationsAction(context, params) {
      try {
        const {
          title,
          categories,
          type,
          frequency,
          emailMessage,
          smsMessage,
          attachSOA,
          bccPropertyEmail,
          inactive
        } = params

        const notification = await axios.post(
          `${process.env.VUE_APP_API_URL}/notifications`,
          {
            title,
            categories,
            type,
            frequency,
            emailMessage,
            smsMessage,
            attachSOA,
            bccPropertyEmail,
            inactive
          },
          {
            withCredentials: true
          }
        )

        return Promise.resolve(notification)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.data == 'CREATE_NOTIFICATION_LIMIT_ERROR') {
          response =
            'Your property has exceeded the maximum notifications you can create.'
        }
        return Promise.reject(response)
      }
    },
    async updateNotificationsAction(context, params) {
      try {
        const {
          title,
          categories,
          type,
          frequency,
          emailMessage,
          smsMessage,
          notificationId,
          attachSOA,
          bccPropertyEmail,
          inactive
        } = params

        const notification = await axios.patch(
          `${process.env.VUE_APP_API_URL}/notifications/${notificationId}`,
          {
            title,
            categories,
            type,
            frequency,
            emailMessage,
            smsMessage,
            attachSOA,
            bccPropertyEmail,
            inactive
          },
          {
            withCredentials: true
          }
        )

        return Promise.resolve(notification)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        return Promise.reject(response)
      }
    },
    async deleteNotificationAction(context, params) {
      try {
        const { notificationId } = params

        const notification = await axios.delete(
          `${process.env.VUE_APP_API_URL}/notifications/${notificationId}`,
          {
            withCredentials: true
          }
        )

        return Promise.resolve(notification)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        return Promise.reject(response)
      }
    }
  }
}
